import { render } from "./Listsother.vue?vue&type=template&id=10f360d2&scoped=true"
import script from "./Listsother.vue?vue&type=script&lang=js"
export * from "./Listsother.vue?vue&type=script&lang=js"

import "./Listsother.vue?vue&type=style&index=0&id=10f360d2&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f360d2"]])

export default __exports__